import React, { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { authUtils } from '../../utils/authUtils';
import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/i18n/ko-kr';
import { Editor } from '@toast-ui/react-editor';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import axios from 'axios';

export default function PgmVersionRegisterComponent(props) {
  const { pgmNm, id, state, handleVersionRegisterClose, handleVersionOpen, getDataList, setVersionId } = props;
  const auth = useRecoilValue(authAtom);
  const editorRef = useRef();
  let formData = new FormData();

  const registerOrModify = async (formData, config) => {
    if (state === 'register') return await registerBoard(formData, config);
    return await modifyBoard(formData, config);
  };

  const registerBoard = async (formData, config) => {
    return await axios.post(`/api/board`, formData, config);
  };

  const modifyBoard = async (formData, config) => {
    return await axios.patch(`/api/board/version/${id}`, formData, config);
  };

  const versionRegister = () => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };

    formData.append('kind', 'VERSION');
    formData.append('createdId', auth.userid);
    formData.append('subject', pgmNm);
    formData.append('content', editorRef.current?.getInstance().getHTML());
    config.headers['Content-Length'] = editorRef.current?.getInstance().getHTML().length;

    registerOrModify(formData, config)
      .then((response) => {
        alert(response.data.message);
        handleVersionRegisterClose();
        getDataList();
        setVersionId(response.data.id);
        handleVersionOpen();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const getBoardDetail = async () => {
    const response = await axios.get(`/api/board/version/${id}`);

    const htmlToEditor = response.data?.content;
    editorRef.current?.getInstance().setHTML(htmlToEditor);
  };

  useEffect(async () => {
    if (state === 'modify') {
      await getBoardDetail();
    }
  }, []);

  return (
    <>
      <div>
        <div class="version">
          <Box component="form" noValidate sx={{ maxWidth: 1200, minWidth: 1000, minHeight: 500, ml: 1 }}>
            <Editor previewStyle="vertical" height="800px" initialValue="" ref={editorRef} initialEditType={'wysiwyg'} plugins={[colorSyntax]} language={'ko-KR'} />
          </Box>
        </div>
      </div>
      <div>
        {authUtils.useIsAdmin() && (
          <Button variant="contained" onClick={versionRegister}>
            {!!id ? '수정' : '등록'}
          </Button>
        )}
      </div>
    </>
  );
}
